export default function initEditUserForm() : void {
    document.querySelectorAll<HTMLButtonElement>('.js-edit-user-modal-toggler').forEach($modalToggler => {
        new EditUserForm($modalToggler);
    });
}

class EditUserForm {
    constructor($modalToggler: HTMLButtonElement) {
        const formName = $modalToggler.dataset.userFormName;
        const $form = document.querySelector<HTMLFormElement>(`form[name="${formName}"]`);

        // User data
        const userId = $modalToggler.dataset.userId || '';
        const userFirstname = $modalToggler.dataset.userFirstname || '';
        const userLastname = $modalToggler.dataset.userLastname || '';
        const userEmail = $modalToggler.dataset.userEmail || '';
        const userRole = $modalToggler.dataset.userRole || '';
        const userIsActive = $modalToggler.dataset.userIsActive === 'true';

        if ($form) {
            $modalToggler.addEventListener('click', () => {
                ($form.querySelector('.js-edit-form-id-input') as HTMLInputElement).value = userId;
                ($form.querySelector('.js-edit-form-firstname-input') as HTMLInputElement).value = userFirstname;
                ($form.querySelector('.js-edit-form-lastname-input') as HTMLInputElement).value = userLastname;
                ($form.querySelector('.js-edit-form-email-input') as HTMLInputElement).value = userEmail;
                ($form.querySelector('.js-edit-form-role-input') as HTMLInputElement).value = userRole;
                ($form.querySelector('.js-edit-form-role-input') as HTMLInputElement).value = userRole;

                const $changeActiveStateButton = $form.querySelector<HTMLButtonElement>('.js-edit-form-change-active-state-button');

                if (userIsActive) {
                    ($changeActiveStateButton?.querySelector('.text') as HTMLElement).innerText = $changeActiveStateButton?.dataset.disableLabel || '';
                } else {
                    ($changeActiveStateButton?.querySelector('.text') as HTMLElement).innerText = $changeActiveStateButton?.dataset.enableLabel || '';
                }
            });
        }
    }
}
